import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import NotFound from '@/screens/NotFound/NotFound';
import { currentDomain } from '@/utils/branding';
import styles from './LegalDocumentPage.module.scss';

type DocType = 'terms' | 'privacy';

const VALID_COMBOS: Record<string, boolean> = {
  'ae/en': true,
  'ae/ar': true,
  'sa/en': true,
  'sa/ar': true,
};

type ContentModule = { content: string; dir: string };

const loadModule = async (
  docType: DocType,
  country: string,
  lang: string
): Promise<ContentModule> => {
  const key = `${country}/${lang}`;
  if (docType === 'privacy') {
    if (key === 'ae/en') return import('@/content/privacy/ae-en');
    if (key === 'ae/ar') return import('@/content/privacy/ae-ar');
    if (key === 'sa/en') return import('@/content/privacy/sa-en');
    return import('@/content/privacy/sa-ar');
  }
  if (key === 'ae/en') return import('@/content/terms/ae-en');
  if (key === 'ae/ar') return import('@/content/terms/ae-ar');
  if (key === 'sa/en') return import('@/content/terms/sa-en');
  return import('@/content/terms/sa-ar');
};

type Props = {
  docType: DocType;
};

const LegalDocumentPage = ({ docType }: Props) => {
  const { country = '', lang = '' } = useParams<{ country: string; lang: string }>();
  const [content, setContent] = useState<string | null>(null);
  const [dir, setDir] = useState<string>('ltr');
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!VALID_COMBOS[`${country}/${lang}`]) {
      setNotFound(true);
      return;
    }
    setContent(null);
    setNotFound(false);
    loadModule(docType, country, lang).then(mod => {
      setContent(mod.content.replace(/\{\{DOMAIN\}\}/g, currentDomain));
      setDir(mod.dir);
    });
  }, [docType, country, lang]);

  if (notFound) return <NotFound />;
  if (!content) return null;

  return (
    <div className={styles.page} dir={dir}>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default LegalDocumentPage;
